import { EListingActions } from '../../../constants/actionTypes/listing';
import { DEFAULT_META } from '../../../constants/meta';
import { TReduxActions } from '../../../types/redux';
import { IRealtorsListing } from '../../../types/redux/realtors';

export const defaultState = {
  items: [],
  page: 1,
  meta: DEFAULT_META,
};

export function realtorsListingReducer(state: IRealtorsListing = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EListingActions.SET_REALTORS_ITEMS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case EListingActions.SET_REALTORS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
}
